// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__k46uq","tab":"ProcedureTabs_tab__szumc"};